import axios from 'axios';
import ElementUi,{Loading,Message,MessageBox } from 'element-ui';
import {baseURL} from './url'
import router from '@/router'
import Cookie from "js-cookie";
// let loading =null;
// const  close = ()=>{
//   setTimeout(() => {
//     loading&&loading.close()
//   }, 500);
// }
class Axios {
    constructor(props) {
        this.axios = null;
        this.init();
    }
    init() {
        
        const config = {
            baseURL,
            timeout: 30000,
            headers:{
              'Content-Type':'application/x-www-form-urlencoded'
            }
        }
        this.axios = axios.create(config);
        this.axios.interceptors.request.use(function (config) {
            // console.log(Cookie.get('token'))
            config.headers.token=Cookie.get('token')||''
            // 在发送请求之前做些什
            // if(config.url!='http://www.schtyg.cn:3930/admin/order/is_or'){
            //   loading = Loading.service()
            // }
            
            return config;
          }, function (error) {
            // 对请求错误做些什么
            // close()
            return Promise.reject(error);
          });
        // 添加响应拦截器
        this.axios.interceptors.response.use(function (response) {
            // 对响应数据做点什么
            close()
            if(response.data.code==0){
              MessageBox.confirm(response.data.errorMsg,'提示', {
                confirmButtonText: '确定',
                showCancelButton:false,
                type: 'warning',
              }).then(() => {
              }).catch(() => {  
              });
            }else if(response.data.code==-1){
              Message({
                message: response.data.errorMsg,
                type: "warning"
              });
              Cookie.set("avatar", "");
              Cookie.set("name", "");
              Cookie.set("roleType", "");
              Cookie.set("token", "");
              router.push('/login')
            }else if(response.data.code==1){
              return response;
            }
            // if(response.data.code==213||response.data.code==400){
            //   Message({
            //     message: response.data.msg,
            //     type: "warning"
            //   });
            //   router.push('/login')
            // }
            
          }, function (error) {
            // ElementUi.Notification.error({
            //     title: error.response.status,
            //     message:error.response.data.errors[0].message
            //  })
            
            // close()
            return Promise.reject(error);
          });
    }
    get(url,config){
       return this.axios.get(baseURL+url)
    }
    post(url,data,config){
      // console.log(baseURL)
      return this.axios.post(baseURL+url,data)
    }
    async all(props) {
       return  await axios.all([...props]);
    }



}

export default new Axios();


// WEBPACK FOOTER //
// ./src/utils/axios.js